module.exports = __webpack_public_path__ + "static/media/testing-eirich-2-s.43c56a2e.jpg";